// eslint-disable-next-line import/prefer-default-export
import {
  URL_ADAF,
  URL_ADDRESS_PAGE,
  URL_BUYER_INVOICES,
  URL_INVOICES,
  URL_MANAGEMENT_INVOICES,
  URL_OFFER_CREATE,
  URL_PAYOUTS,
  URL_SEARCH,
  URL_SELLER_ORGANIZATION_MANAGE,
  URL_SUBSCRIPTION,
  URL_USER_DEALS,
  URL_USER_INBOX,
  URL_USER_LEADS,
  URL_USER_NOTIFICATIONS,
  URL_USER_OFFERS,
  URL_USER_ORGANIZATION_MANAGE,
  URL_USER_ORGANIZATION_PAYMENT_ACCOUNT,
  URL_USER_ORGANIZATION_PAYMENT_METHOD_BUYER,
  URL_USER_ORGANIZATION_PAYMENT_METHOD_SELLER,
  URL_USER_ORGANIZATION_TEAM,
  URL_USER_PROFILE_INVOICE,
  URL_USER_PROFILE_MANAGE,
  URL_USER_PROPOSAL,
} from '@elements/tools/routes/routes';
import { trans } from '@elements/translation';
import type { MenuItem, MenuItemButton, MenuItemDivider, MenuItemGroup, MenuItemLink } from '@global-types/nav/menuItem';
import IconMagnifyingGlass from '@icons/ph_magnifying-glass.svg';
import IconEnvelope from '@icons/ph_envelope.svg';
import IconHeartStraight from '@icons/ph_heart-straight.svg';
import IconAlignTop from '@icons/ph_align-top.svg';
import IconTag from '@icons/ph_tag.svg';
import IconReceip from '@icons/ph_receip.svg';
import IconBriefcase from '@icons/ph_briefcase.svg';
import IconList from '@icons/ph_list.svg';
import IconBuildings from '@icons/ph_buildings.svg';
import IconTrendUp from '@icons/ph_trend-up.svg';
import IconUserCircle from '@icons/ph_user-circle.svg';
import IconBellRinging from '@icons/ph_bell-ringing.svg';
import IconRent from '@icons/ph_rent.svg';
import IconPlus from '@icons/ph_plus.svg';

export const ACCOUNT_PROFILE = {
  NO_PROFILE: 'NO_PROFILE',
  BUYER: 'BUYER',
  SELLER: 'SELLER',
  BOTH: 'BOTH',
  MOBILE_MENU_ANONYMOUS: 'anonymous',
};

export const SELLER_PROFILES = {
  SELLER_BOOST: 'SellerBoost',
  SELLER_BOOST_ASS: 'SellerBoostAss',
};

// @TODO Ajouter un lien type aux différents liens pour etre iso autres menus

export const SEARCH_LINK: MenuItemLink = {
  type: 'link',
  name: trans('user_menu.search'),
  link: URL_SEARCH,
  icon: IconMagnifyingGlass,
  iconName: 'ph_magnifying-glass',
  similarLinks: [
    '/coworking', '/location',
  ],
};

const INBOX_LINK: MenuItemLink = {
  type: 'link',
  name: trans('user_menu.inbox'),
  link: URL_USER_INBOX,
  icon: IconEnvelope,
  iconName: 'ph_envelope',
  notification: 'unread_messages',
};

const SELECTION_ITEM_LINK: MenuItemLink = {
  type: 'link',
  name: trans('user_menu.selection_item'),
  link: URL_USER_PROPOSAL,
  icon: IconHeartStraight,
  iconName: 'ph_heart-straight',
  notification: 'unread_match_proposal',
};

const LEADS_LINK: MenuItemLink = {
  type: 'link',
  name: trans('user_menu.leads'),
  link: URL_USER_LEADS,
};

const TEAM_LINK: MenuItemLink = {
  type: 'link',
  name: trans('user_menu.team'),
  link: URL_USER_ORGANIZATION_TEAM,
};

const MANAGE_LINK: MenuItemLink = {
  type: 'link',
  name: trans('user_menu.organization'),
  link: URL_USER_ORGANIZATION_MANAGE,
};

const MANAGE_LINK_SELLER: MenuItemLink = {
  type: 'link',
  name: trans('user_menu.organization'),
  link: URL_SELLER_ORGANIZATION_MANAGE,
};

const DEALS_LINK: MenuItemLink = {
  type: 'link',
  name: trans('user_menu.deals'),
  link: URL_USER_DEALS,
  icon: IconAlignTop,
  iconName: 'ph_align-top',
};

const OFFERS_LINK: MenuItemLink = {
  type: 'link',
  name: trans('user_menu.offers'),
  link: URL_USER_OFFERS,
  icon: IconTag,
  iconName: 'ph_tag',
};

const SUBSCRIPTION_LINK: MenuItemLink = {
  type: 'link',
  name: trans('user_menu.subscriptions'),
  link: URL_SUBSCRIPTION,
  icon: IconReceip,
  iconName: 'ph_receip',
};

const SUBSCRIPTION_LINK_MOBILE: MenuItemLink = {
  type: 'link',
  name: trans('user_menu.subscriptions'),
  link: URL_SUBSCRIPTION,
  icon: IconReceip,
  iconName: 'ph_receip',
  isNew: true,
};

const ORGANIZATION_SUBMENU_BUYER: MenuItemGroup = {
  type: 'button',
  name: trans('user.menu.my_organization'),
  submenus: [
    MANAGE_LINK,
    TEAM_LINK,
    { name: trans('user_menu.gestion_parameters'), link: URL_USER_ORGANIZATION_PAYMENT_METHOD_BUYER, requiresPayBuyer: true } as MenuItemLink,
  ],
  icon: IconBriefcase,
  iconName: 'ph_briefcase',
};

const ORGANIZATION_SUBMENU_SELLER: MenuItemGroup = {
  type: 'button',
  name: trans('user.menu.my_organization'),
  submenus: [
    MANAGE_LINK_SELLER,
    TEAM_LINK,
    { name: trans('user_menu.adaf_invoices'), link: URL_USER_PROFILE_INVOICE } as MenuItemLink,
    { name: trans('user_menu.invoices.management'), link: URL_MANAGEMENT_INVOICES, hasKycActive: true } as MenuItemLink,
    { name: trans('user_menu.gestion_parameters'), link: URL_USER_ORGANIZATION_PAYMENT_METHOD_SELLER, hasKycActive: true } as MenuItemLink,
  ],
  icon: IconBriefcase,
  iconName: 'ph_briefcase',
};

export const PLUS_MENU_MOBILE: MenuItemButton = {
  type: 'button',
  name: trans('user_menu.plus'),
  icon: IconList,
  iconName: 'ph_list',
  event: 'show-slidein-nav',
};

export const SELLER_MOBILE_MENU: MenuItem[] = [
  INBOX_LINK,
  OFFERS_LINK,
  SUBSCRIPTION_LINK_MOBILE,
  PLUS_MENU_MOBILE,
];

export const SELLER_MENU: MenuItem[] = [
  INBOX_LINK,
  {
    name: trans('user_menu.property_holdings'),
    submenus: [
      OFFERS_LINK,
      { name: trans('user_menu.spaces'), link: URL_ADDRESS_PAGE } as MenuItemLink,
    ],
    icon: IconBuildings,
    iconName: 'ph_buildings',
  } as MenuItemGroup,
  {
    name: trans('user_menu.sales'),
    submenus: [
      LEADS_LINK,
      { name: trans('user_menu.adaf'), link: URL_ADAF } as MenuItemLink,
    ],
    icon: IconTrendUp,
    iconName: 'ph_trend-up',
  } as MenuItemGroup,
  {
    name: trans('user_menu.invoicing'),
    submenus: [
      SUBSCRIPTION_LINK,
      { name: trans('user_menu.pay_invoices'), link: URL_INVOICES } as MenuItemLink,
      { name: trans('user_menu.payouts'), link: URL_PAYOUTS } as MenuItemLink,
      { name: trans('user_menu.invoices.settings'), link: URL_USER_ORGANIZATION_PAYMENT_ACCOUNT } as MenuItemLink,
    ],
    icon: IconReceip,
    iconName: 'ph_receip',
    isNew: true,
  } as MenuItemGroup,
  { name: 'divider-1', type: 'divider', divider: true } as MenuItemDivider,
  ORGANIZATION_SUBMENU_SELLER,
  { name: 'divider-2', type: 'divider', divider: true } as MenuItemDivider,
];

export const SELLER_MENU_PLUS: MenuItem[] = [
  {
    name: trans('user_menu.property_holdings'),
    submenus: [
      { name: trans('user_menu.spaces'), link: URL_ADDRESS_PAGE } as MenuItemLink,
      { name: trans('user_menu.offers'), link: URL_USER_OFFERS } as MenuItemLink,
    ],
    icon: IconBuildings,
    iconName: 'ph_buildings',
  } as MenuItemGroup,
  {
    name: trans('user_menu.sales'),
    submenus: [
      LEADS_LINK,
      { name: trans('user_menu.adaf'), link: URL_ADAF } as MenuItemLink,
    ],
    icon: IconTrendUp,
    iconName: 'ph_trend-up',
  } as MenuItemGroup,
  {
    name: trans('user_menu.invoicing'),
    submenus: [
      { name: trans('user_menu.subscriptions'), link: URL_SUBSCRIPTION } as MenuItemLink,
      { name: trans('user_menu.pay_invoices'), link: URL_INVOICES } as MenuItemLink,
      { name: trans('user_menu.payouts'), link: URL_PAYOUTS } as MenuItemLink,
      { name: trans('user_menu.invoices.settings'), link: URL_USER_ORGANIZATION_PAYMENT_ACCOUNT } as MenuItemLink,
    ],
    icon: IconReceip,
    iconName: 'ph_receip',
  } as MenuItemGroup,
  { name: 'divider-1', type: 'divider' } as MenuItemLink,
  ORGANIZATION_SUBMENU_SELLER,
  { name: trans('user_menu.profile'), link: URL_USER_PROFILE_MANAGE, icon: IconUserCircle, iconName: 'ph_user-circle' } as MenuItemLink,
  { name: trans('user_menu.notifications'), link: URL_USER_NOTIFICATIONS, icon: IconBellRinging, iconName: 'ph_bell-ringing' } as MenuItemLink,
  { name: 'divider-2', type: 'divider' } as MenuItemLink,
  {
    name: trans('user_menu.main.see_search'),
    link: URL_SEARCH,
    icon: IconMagnifyingGlass,
    iconName: 'ph_magnifying-glass',
    similarLinks: [ '/coworking', '/location' ],
  } as MenuItemLink,
];

export const BUYER_MOBILE_MENU: MenuItem[] = [
  SEARCH_LINK,
  INBOX_LINK,
  SELECTION_ITEM_LINK,
  PLUS_MENU_MOBILE,
];

export const BUYER_MENU: MenuItem[] = [
  SEARCH_LINK,
  INBOX_LINK,
  SELECTION_ITEM_LINK,
  DEALS_LINK,
  { name: 'divider-1', type: 'divider' } as MenuItemDivider,
  { name: trans('user_menu.invoices'), link: URL_BUYER_INVOICES, icon: IconRent, iconName: 'ph_rent', hasIconStroke: true } as MenuItemLink,
  { name: 'divider-2', type: 'divider' } as MenuItemDivider,
  ORGANIZATION_SUBMENU_BUYER,
  { name: 'divider-3', type: 'divider' } as MenuItemDivider,
];

export const BUYER_MENU_PLUS: MenuItem[] = [
  SELECTION_ITEM_LINK,
  DEALS_LINK,
  { name: 'divider-1', type: 'divider' } as MenuItemDivider,
  ORGANIZATION_SUBMENU_BUYER,
  { name: trans('user_menu.profile'), link: URL_USER_PROFILE_MANAGE, icon: IconUserCircle, iconName: 'ph_user-circle' } as MenuItemLink,
  { name: trans('user_menu.notifications'), link: URL_USER_NOTIFICATIONS, icon: IconBellRinging, iconName: 'ph_bell-ringing' } as MenuItemLink,
  { name: 'divider-2', type: 'divider' } as MenuItemDivider,
  { name: trans('user_menu.invoices'), link: URL_BUYER_INVOICES, icon: IconRent, iconName: 'ph_rent', hasIconStroke: true } as MenuItemLink,
  { name: 'divider-3', type: 'divider' } as MenuItemDivider,
  { name: trans('user_menu.main.create_offer'), link: URL_OFFER_CREATE, icon: IconPlus, iconName: 'ph_plus', hideOnBothProfile: true } as MenuItemLink,
];

export const UNQUALIFIED_MENU: MenuItem[] = [
  SEARCH_LINK,
  INBOX_LINK,
  SELECTION_ITEM_LINK,
  DEALS_LINK,
  {
    type: 'button',
    name: trans('user_menu.property_holdings'),
    submenus: [
      { name: trans('user_menu.offers'), link: URL_USER_OFFERS } as MenuItemLink,
      { name: trans('user_menu.spaces'), link: URL_ADDRESS_PAGE } as MenuItemLink,
    ],
    icon: IconBuildings,
    iconName: 'ph_buildings',
  } as MenuItemGroup,
  { name: 'divider-1', type: 'divider' } as MenuItemDivider,
  ORGANIZATION_SUBMENU_BUYER,
  { name: 'divider-2', type: 'divider' } as MenuItemDivider,
];

export const UNQUALIFIED_MENU_PLUS: MenuItem[] = [
  ...UNQUALIFIED_MENU,
  { name: trans('user_menu.main.create_offer'), link: URL_OFFER_CREATE, icon: IconPlus, iconName: 'ph_plus' } as MenuItemLink,
];

export const PROFILE_MENU: MenuItemLink[] = [
  { name: trans('user_menu.profile'), link: URL_USER_PROFILE_MANAGE, icon: IconUserCircle, iconName: 'ph_user-circle', type: 'link' } as MenuItemLink,
  { name: trans('user_menu.notifications'), link: URL_USER_NOTIFICATIONS, icon: IconBellRinging, iconName: 'ph_bell-ringing', type: 'link' } as MenuItemLink,
];

export const DISPLAYED_MENU = {
  seller: 'seller',
  buyer: 'buyer',
};
